import { assetUrl } from '../config/asset-config';

(function () {
    'use strict';

    angular.module('thankview.pricing', ['ngTouch'])
        .controller('PricingController', ['$scope', '$rootScope', 'ajax', 'pricingService', 'stripeService', '$window', '$timeout', function ($scope, $rootScope, ajax, pricingService, stripeService, $window, $timeout) {
            let loadedStripe = false;
            var stripe;
            var stripeIsProcessing;
            var selectedOption;

            $scope.$on('open-paywall', function () {
                $scope.loadStripe();
            });

            $scope.init = function () {
                $scope.now = new Date();

                if (!$scope.business && $scope.configUser) {
                    pricingService.fetchConsumer().then(function (response) {
                        $scope.pricing = response.pricing;
                    });
                }

                if ($window.location.pathname === '/account/credits') {
                    $scope.loadStripe();
                }
            };

            $scope.loadStripe = function () {
                if (loadedStripe) {
                    return;
                }

                loadedStripe = true;

                stripeService.load();
                $scope.initStripe();
            };

            $scope.initStripe = function () {
                if (!$window.StripeCheckout) {
                    $timeout($scope.initStripe, 100);
                    return;
                }

                stripe = StripeCheckout.configure({
                    key: config.stripe,
                    image: assetUrl('assets/img/logo_icon_uni.png'),
                    allowRememberMe: false,
                    zipCode: false,
                    token: function (token) {
                        stripeIsProcessing = true;
                        $scope.processToken(token);
                    },
                    opened: function () {
                        stripeIsProcessing = false;
                        $rootScope.$broadcast('close-loading');
                    },
                    closed: function () {
                        if (stripeIsProcessing) {
                            $rootScope.$broadcast('open-loading');
                        }
                    },
                });
            };

            $scope.openStripe = function (option, agreeTerms) {
                if ($scope.business && !agreeTerms) {
                    $rootScope.$broadcast('open-message', 'To purchase, please agree to our terms of service.');
                    return;
                }

                $rootScope.$broadcast('open-loading');

                selectedOption = option;

                stripe.open({
                    name: 'ThankView',
                    description: $scope.business ? option.name : option.amount + ' ThankViews',
                    // email: config.user.email ? config.user.email : undefined,
                    zipCode: false,
                    currency: 'usd',
                    amount: option.cost ? option.cost : option.setup_fee + option.amount_due + option.cx_accelerator_fee + option.thankgiving_fee + option.odder_fee,
                });
            };

            $scope.processToken = function (token) {
                var params = {
                    payment_id: selectedOption.id,
                    token: (token && token.id ? token.id : null),
                    client_ip: (token && token.client_ip ? token.client_ip : null),
                    cost: selectedOption.cost ? selectedOption.cost : selectedOption.setup_fee + selectedOption.amount_due + selectedOption.cx_accelerator_fee + selectedOption.thankgiving_fee + selectedOption.odder_fee,
                    email: token.email,
                };

                ajax.post('/api/purchase', params).then(function () {
                    if ($window.location.pathname === '/account/credits') {
                        $scope.updateCredits();

                        var message = 'Your purchase of ' + selectedOption.amount + ' ThankViews is successful!';
                        $rootScope.$broadcast('open-message', message);
                    } else {
                        $window.location.reload();
                    }
                });
            };

            $scope.init();
        }]);
}());
